var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrosoftLogo = function SvgMicrosoftLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ms-symbollockup_mssymbol_19",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1528",
    x: 3.5,
    y: 3.5,
    fill: "#F05125",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1529",
    x: 3.5,
    y: 22.5,
    fill: "#33A0DA",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    x: 22.5,
    y: 3.5,
    fill: "#7EBB42",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1531",
    x: 22.5,
    y: 22.5,
    fill: "#FDB813",
    width: 16,
    height: 16
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft_logo.877534b4af5547d1cb911d9483a984e3.svg";